/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: bfa409c6b1ac
 */

import * as z from "zod";
import {
  AssetRelationInfo,
  AssetRelationInfo$zodSchema,
} from "./assetrelationinfo.js";

export type AssetRelationsResponse = {
  failed?: Array<AssetRelationInfo> | undefined;
  success?: Array<AssetRelationInfo> | undefined;
};

export const AssetRelationsResponse$zodSchema: z.ZodType<
  AssetRelationsResponse
> = z.object({
  failed: z.array(AssetRelationInfo$zodSchema).optional(),
  success: z.array(AssetRelationInfo$zodSchema).optional(),
});
